import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosataracab() {


const cardData = {
keyword: "Pune to Satara Cab",
headingDescription: "Pune to Satara Cab provides convenient private road transportation for travelers commuting between Pune and Satara for business, family visits, education, tourism, religious journeys and personal travel. Citysky Cabs offers Sedan, Ertiga, Innova and Innova Crysta options according to passenger count, luggage and comfort requirements. One-way and round-trip journeys can be arranged for individuals, couples, families and groups, providing direct connectivity toward Satara and nearby destinations such as Karad, Wai, Mahabaleshwar and the surrounding Western Ghats.",
topPlaces: [
{
title: "Satara",
description: "Satara is the main destination on this route and is known for its historical heritage, natural surroundings and important residential and commercial areas. A private cab from Pune provides direct transportation for business travelers, families, students and visitors carrying luggage."
},
{
title: "Kaas Plateau",
description: "Kaas Plateau is a popular natural attraction near Satara, particularly known for its seasonal wildflowers and scenic landscapes. Travelers visiting Satara for sightseeing can include Kaas in their itinerary and use a private cab for convenient movement between the city and surrounding attractions."
},
{
title: "Thoseghar Waterfalls",
description: "Thoseghar Waterfalls is a well-known scenic attraction in the Satara region, surrounded by hills and greenery. A private vehicle makes it convenient for families, friends and nature enthusiasts to travel from Satara toward the waterfall and explore the surrounding Western Ghats."
},
{
title: "Ajinkyatara Fort",
description: "Ajinkyatara Fort is an important historical landmark overlooking Satara and offers scenic views of the surrounding region. Visitors traveling from Pune can reach Satara by private cab and conveniently include the fort as part of a local sightseeing itinerary."
},
{
title: "Sajjangad",
description: "Sajjangad is a significant historical and spiritual destination near Satara associated with Samarth Ramdas. It attracts devotees and visitors throughout the year, making it a useful stop for travelers planning a religious or heritage-focused journey around Satara."
},
{
title: "Wai",
"description": "Wai is a historic town near Satara known for its temples, ghats and scenic surroundings along the Krishna River. Travelers taking a Pune to Satara cab can extend their trip toward Wai for sightseeing, religious visits, family outings and exploration of the region."
},
{
title: "Mahabaleshwar",
"description": "Mahabaleshwar is a popular hill station located in the broader Satara region and is known for viewpoints, greenery, waterfalls and pleasant mountain landscapes. Private transportation makes it convenient for families and groups combining Satara travel with a hill-station itinerary."
},
{
title: "Panchgani",
"description": "Panchgani is a scenic hill destination near Satara featuring viewpoints, valleys and mountain landscapes. Travelers can include Panchgani in an extended Satara-region road trip, with a private cab offering flexibility for families and groups."
},
{
title: "Pratapgad Fort",
"description": "Pratapgad Fort is a prominent historical destination in the Satara district area and attracts visitors interested in Maratha history and mountain scenery. A private cab is useful for travelers planning to combine heritage sightseeing with their Satara journey."
},
{
title: "Karad",
"description": "Karad is an important city in the Satara district and a significant destination for business, education, family visits and regional travel. Passengers traveling through the Satara region can conveniently include Karad in their itinerary using dedicated private transportation."
}
],
services: [
{
name: "pune to satara cab price",
description: "pune to satara cab price can vary according to the selected vehicle, journey type and travel requirements. Travelers can choose a suitable cab based on passenger count, luggage and whether they need one-way or round-trip transportation."
},
{
name: "pune to satara cab service",
description: "pune to satara cab service provides direct private transportation between Pune and Satara for families, professionals, students and individual travelers. The journey can be planned according to the preferred pickup location and vehicle category."
},
{
name: "pune to satara one way cab",
description: "pune to satara one way cab is suitable for travelers who need direct transportation toward Satara without arranging a return journey. It can be useful for relocation, business visits, family travel, education and personal trips."
},
{
name: "pune to karad cab",
description: "pune to karad cab provides direct private transportation from Pune toward Karad in the Satara district. It can support business travel, family visits, educational journeys and personal trips with vehicle options suitable for different passenger groups."
},
{
name: "karad to pune cab",
description: "karad to pune cab offers convenient private road transportation for passengers traveling from Karad toward Pune. It is suitable for professionals, students, families and individuals who prefer a dedicated vehicle for their return or onward journey."
},
{
name: "pune to karad taxi",
description: "pune to karad taxi provides private intercity connectivity between Pune and Karad. Travelers can arrange suitable transportation for business activities, family visits, education, relocation and other personal travel requirements."
},
{
name: "pune to satara cab booking",
description: "pune to satara cab booking allows passengers to organize their private vehicle before the scheduled journey. Travelers can communicate their pickup point, destination, travel date, passenger count and preferred vehicle category."
},
{
name: "pune to satara taxi booking online",
description: "pune to satara taxi booking online provides a convenient booking-oriented option for travelers planning private transportation. Passengers can share their route, schedule and vehicle requirements while arranging their intercity journey."
},
{
name: "pune to satara cab fare",
description: "pune to satara cab fare depends on factors such as vehicle category, trip type and specific travel requirements. Travelers can select a practical sedan or spacious vehicle according to group size, luggage and comfort preferences."
},
{
name: "pune to satara taxi fare",
description: "pune to satara taxi fare can vary according to the selected vehicle and journey arrangement. One-way and round-trip options can be considered depending on the passenger's itinerary, travel schedule and transportation requirements."
},
{
name: "pune to satara cab price",
description: "pune to satara cab price is an important consideration when selecting private transportation for the route. Travelers can choose a vehicle according to passenger count, luggage and the type of journey they are planning."
},
{
name: "pune to satara taxi charges",
description: "pune to satara taxi charges can vary depending on the vehicle category, journey type and other applicable travel requirements. Passengers can provide their itinerary and preferred vehicle details while planning their transportation."
},
{
name: "best pune to satara cab service",
description: "best pune to satara cab service provides dedicated private transportation for travelers covering the Pune-Satara route. It can support business journeys, family trips, sightseeing, education and personal travel with multiple vehicle choices."
},
{
name: "cheap pune to satara cab",
description: "cheap pune to satara cab provides a practical transportation option for passengers looking to manage their intercity travel expenses. Travelers can choose an appropriate vehicle according to their group size, luggage and comfort requirements."
},
{
name: "pune to satara one way cab",
description: "pune to satara one way cab provides direct transportation for passengers traveling only toward Satara. It is useful for relocation, work visits, family journeys, education and travelers who have separate arrangements for their return."
},
{
name: "pune to satara round trip taxi",
description: "pune to satara round trip taxi is suitable for travelers planning to visit Satara and return to Pune after completing their work, family function, sightseeing or religious itinerary. A dedicated vehicle can support the planned return journey."
},
{
name: "pune to satara innova cab",
description: "pune to satara innova cab provides a spacious private vehicle option for families and groups traveling together. The Innova can accommodate passengers and luggage comfortably and is suitable for both short regional trips and longer sightseeing plans."
},
{
name: "pune to satara innova crysta cab",
description: "pune to satara innova crysta cab provides a spacious and comfortable option for families, executives and groups traveling between Pune and Satara. It can be considered when passengers require enhanced comfort and useful luggage capacity."
},
{
name: "pune to satara ertiga cab",
description: "pune to satara ertiga cab offers a practical multi-passenger option for families and small groups. The vehicle can be considered for one-way and round-trip journeys where passengers require useful seating and luggage space."
},
{
name: "pune to satara sedan cab",
description: "pune to satara sedan cab provides a practical private transportation option for individuals, couples and smaller families. It can be arranged for business travel, personal visits, education and sightseeing between Pune and Satara."
}
],
tableData: [
["pune to satara cab price"],
["pune to satara cab service"],
["pune to satara one way cab"],
["pune to karad cab"],
["karad to pune cab"],
["pune to karad taxi"],
["pune to satara cab booking"],
["pune to satara taxi booking online"],
["pune to satara cab fare"],
["pune to satara taxi fare"],
["pune to satara cab price"],
["pune to satara taxi charges"],
["best pune to satara cab service"],
["cheap pune to satara cab"],
["pune to satara one way cab"],
["pune to satara round trip taxi"],
["pune to satara innova cab"],
["pune to satara innova crysta cab"],
["pune to satara ertiga cab"],
["pune to satara sedan cab"]
],
whychoose: [
{
WhyChooseheading: "Direct Pune to Satara Connectivity",
WhyChoosedescription: "A dedicated cab provides direct road transportation between Pune and Satara without requiring passengers to change vehicles during the journey. This is useful for families, professionals, students and travelers carrying luggage."
},
{
WhyChooseheading: "Flexible Vehicle Selection",
WhyChoosedescription: "Travelers can select a vehicle according to their group size and comfort requirements. Sedan, Ertiga, Innova and Innova Crysta options can accommodate different passenger and luggage needs for the Pune-Satara journey."
},
{
WhyChooseheading: "One-Way Travel Convenience",
WhyChoosedescription: "One-way transportation is useful for passengers traveling to Satara for relocation, business work, family visits, education or personal requirements. A dedicated vehicle allows travelers to complete the journey without arranging separate transportation along the route."
},
{
WhyChooseheading: "Round-Trip Journey Support",
WhyChoosedescription: "A round-trip taxi can be considered by travelers who need to return to Pune after completing their work, sightseeing, family function or religious itinerary in Satara and nearby destinations."
},
{
WhyChooseheading: "Useful for Satara Sightseeing",
WhyChoosedescription: "Satara offers access to attractions such as Kaas Plateau, Thoseghar Waterfalls, Ajinkyatara Fort and Sajjangad. Private transportation gives travelers flexibility to combine the main city with nearby sightseeing locations."
},
{
WhyChooseheading: "Karad Travel Option",
WhyChoosedescription: "Travelers heading toward Karad can also arrange private transportation from Pune. This provides a convenient solution for business visits, family travel, educational requirements and regional journeys within the Satara district."
},
{
WhyChooseheading: "Comfortable Family Travel",
WhyChoosedescription: "Families can travel together in a dedicated vehicle while keeping their luggage with them throughout the journey. Spacious options such as Ertiga, Innova and Innova Crysta can be considered for larger groups."
},
{
WhyChooseheading: "Suitable for Business and Personal Trips",
WhyChoosedescription: "The Pune-Satara route serves a variety of travel requirements, including business visits, family journeys, education and tourism. A private cab allows passengers to plan their transportation around their own schedule and destination."
}
]
};
















const faqData = [
{
question: "How do I arrange a Pune to Satara Cab with Citysky Cabs?",
answer: "Travellers can enquire by sharing their Pune pickup point, Satara destination, journey date, passenger count, preferred departure time, and one-way or round-trip requirement. Citysky Cabs can coordinate the cab according to the planned schedule and specific travel needs."
},
{
question: "Can I travel directly from Pune to Satara by private cab?",
answer: "A private cab can be arranged for passengers who prefer direct road travel between Pune and Satara. Families, couples, professionals, and small groups can discuss their preferred pickup location, vehicle requirement, departure timing, and final destination when making an enquiry."
},
{
question: "Is one-way Pune to Satara Cab service available?",
answer: "Passengers who only need to travel from Pune to Satara can enquire about a one-way cab. Details such as the Pune pickup address, Satara drop location, travel date, passenger count, luggage, and preferred departure time can be provided during the booking process."
},
{
question: "Can I book a return cab from Satara to Pune?",
answer: "Travellers who need transportation back to Pune after completing their visit to Satara can enquire about a round-trip arrangement. Sharing the expected return date and timing helps in planning the cab requirement for both the onward and return journeys."
},
{
question: "Is a Pune to Satara Cab suitable for family trips?",
answer: "Families can consider private cab travel when they want to stay together throughout the journey. A dedicated vehicle can be useful for groups travelling with children, senior citizens, or luggage and can make it easier to coordinate departure times and planned breaks."
},
{
question: "Can I hire a cab from Pune to Satara for a wedding or function?",
answer: "Private cab transportation can be useful for attending weddings, receptions, family gatherings, religious programs, and other functions in Satara. Passengers can provide the event venue, pickup location, timing, group size, and return requirement while making the enquiry."
},
{
question: "Can business travellers use Pune to Satara Cab Service?",
answer: "Professionals travelling to Satara for meetings, client visits, office work, industrial requirements, training programs, or other business activities can enquire about a private cab. The journey can be coordinated according to the traveller's work schedule and exact destination."
},
{
question: "Can I book a Pune to Satara Cab for sightseeing?",
answer: "Travellers planning to explore Satara and nearby attractions can discuss a private cab requirement with Citysky Cabs. Sharing the preferred sightseeing locations and duration of the trip can help in coordinating transportation around the planned itinerary."
},
{
question: "Can I carry luggage while travelling from Pune to Satara by cab?",
answer: "Passengers can mention the approximate quantity of luggage during the booking enquiry, especially when travelling with family bags or event-related belongings. Passenger count and luggage volume can be considered when discussing the appropriate cab arrangement."
},
{
question: "What details are needed to book a Pune to Satara Cab?",
answer: "The booking enquiry should include the Pune pickup location, Satara drop address, travel date, number of passengers, luggage details, preferred departure time, and one-way or round-trip preference. Any additional stops or special travel requirements can also be shared beforehand."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Kunal More",
feedback:
"I travelled from Pune to Satara for a family function and needed a direct vehicle for everyone. Citysky Cabs arranged the cab after I shared our pickup point and event location. The private travel was convenient because we could stay together and carry all our bags without arranging separate transportation.",
rating: 5
},
{
id: 2,
name: "Miss. Snehal Joshi",
feedback:
"My parents and I travelled from Pune to Satara for a short visit. We chose a private cab because we wanted a simple door-to-door journey without changing vehicles. Citysky Cabs coordinated the booking based on our schedule, and travelling together made the trip comfortable and easy to manage.",
rating: 5
}
];


































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Satara Cab",
  "image": "https://www.cityskycab.in/assets/images/pune-to-satara-cab.webp",
  "description": "Pune to Satara Cab from Citysky Cabs is a convenient private travel option for families, business travellers, individuals and groups travelling between Pune, Satara and Karad. The service covers Pune to Satara Cab Price, Pune to Satara Cab Service, Pune to Satara One Way Cab, Pune to Karad Cab, Karad to Pune Cab, Pune to Karad Taxi and Pune to Satara Cab Booking requirements. Travellers can choose sedan, Ertiga or Innova Crysta vehicles according to passenger count, luggage and journey preferences. One-way drops and round-trip journeys can be arranged with flexible pickup locations across Pune and Pimpri Chinchwad. Citysky Cabs provides private road travel suitable for family visits, business journeys, personal trips and customized Pune to Satara and Karad transportation requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-satara-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Pune to Satara Cab | One Way Taxi, Fare & Booking | +91 8554819191
  </title>

  <meta
    name="description"
    content="Pune to Satara Cab by Citysky Cabs for one-way and round-trip travel. Book sedan, Ertiga or Innova Crysta for Satara and Karad private taxi service from Pune."
  />

  <meta
    name="keywords"
    content="Pune to Satara Cab, Pune to Satara cab price, Pune to Satara cab service, Pune to Satara one way cab, Pune to Karad cab, Karad to Pune cab, Pune to Karad taxi, Pune to Satara cab booking, Pune to Satara taxi, Pune to Satara taxi service, Pune Satara cab service, Pune Satara taxi booking, cab from Pune to Satara, taxi from Pune to Satara, Pune to Satara one way taxi, Pune to Satara round trip cab, Pune to Satara round trip taxi, Pune to Satara cab fare, Pune to Satara taxi fare, Pune to Satara cab charges, Pune to Satara private cab, Pune to Satara car rental, Pune to Satara car booking, Pune to Satara outstation cab, Pune to Satara Innova Crysta cab, Pune to Satara Innova cab, Pune to Satara Ertiga cab, Pune to Satara sedan cab, Pune to Satara AC cab, Pune Airport to Satara cab, Pune Airport to Satara taxi, Pune to Karad cab service, Pune to Karad cab booking, Pune to Karad one way cab, Pune to Karad Innova Crysta cab, Pimpri Chinchwad to Satara cab, PCMC to Satara taxi, Satara to Pune cab, Satara to Pune taxi service, Karad to Pune taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/2.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosataracab;